var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "rb-sidebar",
      class: { "rb-is-minicart-mobile": _vm.isMinicartMobile },
    },
    [
      _c("transition", { attrs: { appear: "", name: "rb-sidebar__overlay" } }, [
        _c("div", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showSidebar,
              expression: "showSidebar",
            },
          ],
          staticClass: "rb-sidebar__overlay",
          on: { click: _vm.onClickHandleClose },
        }),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { appear: "", name: "rb-sidebar__panel" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.showSidebar &&
                  (!(_vm.showMinicart && _vm.isPdp) || _vm.isMobile),
                expression:
                  "showSidebar && (!(showMinicart && isPdp) || isMobile)",
              },
            ],
            staticClass: "rb-sidebar__panel",
            attrs: { id: "sidebar" },
          },
          [
            _vm._t("default"),
            _vm._v(" "),
            _vm.showWishlist ? _c("rb-miniwishlist") : _vm._e(),
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }